module.exports = __webpack_public_path__ + "img/Myers.c19f897a.jpeg";